import React,{useEffect} from "react";
import axiosInstance from "../../axios";

export default function Logout(){
    useEffect(()=>{
        const response=axiosInstance.post("logout/",{
            refreshToken:localStorage.getItem("refreshToken"),
        })
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem('userData');
        localStorage.removeItem('OtpSentDetails');
        localStorage.removeItem('OtpSentToMemberId');

        axiosInstance.defaults.headers['Authorization']=null;
        window.location.href=window.location.origin+"/login/"
    });
}
